import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const scrollToPricing = () => {
    const el = document.getElementById('precio');
    if (!el) return;
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <div className="sticky top-0 z-50 w-full bg-[#1B4332] border-b border-[#2D6A4F]/50 shadow-[0_2px_12px_rgba(45,106,79,0.3)]" data-id="element-402">
      <div className="container mx-auto px-3 py-2 flex items-center justify-between gap-2" data-id="element-403">
        <div className="flex items-center gap-1.5 text-xs md:text-sm font-bold text-white tracking-wide" data-id="element-404">
          <span className="text-sm md:text-base" data-id="element-405">⏰</span>
          <span data-id="element-406">OFERTA POR TIEMPO LIMITADO</span>
          <span className="text-green-300/60 mx-0.5" data-id="element-407">—</span>
          <span data-id="element-408">Cierra en:</span>
          <span className="text-green-300 font-black font-heading tabular-nums text-base md:text-lg animate-pulse" style={{
          animationDuration: '2s'
        }} data-id="element-409">
            {minutes}:{seconds}
          </span>
        </div>

        <button onClick={scrollToPricing} className="shrink-0 bg-green-500 hover:bg-green-400 text-black font-bold text-[10px] md:text-xs px-3 md:px-4 py-1 md:py-1.5 rounded-full transition-colors tracking-wide uppercase whitespace-nowrap shadow-lg shadow-green-500/20" data-id="element-410">
          ASEGURAR MI PRECIO
        </button>
      </div>
    </div>;
}